import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StraightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"straight"}/>
}
